// Compare only explicit secondary-address suffixes, never arbitrary street words.
const PREFIX = "(?:(?:Apartment|Apt|Unit|Suite|Ste|SPC|Space)(?:\\.\\s*|\\s+)|#\\s*)";
const ID = "[A-Za-z0-9]+(?:[-/][A-Za-z0-9]+)*";
const STREET_WORD = /^(?:st|street|rd|road|ave|avenue|way|ln|lane|dr|drive|ct|court|blvd|boulevard|pl|place|hwy|highway)$/i;

function units(text, allowBare = false) {
  let rest = (text || "").trim();
  if (allowBare && new RegExp(`^${ID}$`).test(rest) && !STREET_WORD.test(rest)) {
    return [{ id: rest.toUpperCase(), kind: null }];
  }
  const result = [];
  const pattern = new RegExp(`^(${PREFIX})(${ID})(?=$|[\\s,.])`, "i");
  while (rest) {
    const match = rest.match(pattern);
    if (!match || STREET_WORD.test(match[2])) return null;
    const prefix = match[1].replace(/[.\s]/g, "").toLowerCase();
    result.push({ id: match[2].toUpperCase(), kind: /^(spc|space)$/.test(prefix) ? "space" : "unit" });
    rest = rest.slice(match[0].length).replace(/^[\s,.]+/, "");
  }
  return result.length ? result : null;
}

export function splitStreetUnit(street) {
  const pattern = new RegExp(`\\s+(${PREFIX}\\S+)`, "gi");
  for (const match of (street || "").matchAll(pattern)) {
    const candidate = street.slice(match.index).trim();
    // A street-name false positive must not hide a later real unit suffix.
    if (/^(spc|space)(?:\s|\.)/i.test(candidate) && !units(candidate)) continue;
    return { street: street.slice(0, match.index).trim(), apt: candidate };
  }
  return { street, apt: "" };
}

export function addressUnitConflict({ street, apt }) {
  const embedded = splitStreetUnit(street || "").apt;
  const all = [...(units(embedded) || []), ...(units(apt, true) || [])];
  return all.some(unit => unit.id !== all[0].id ||
    (unit.kind && all[0].kind && unit.kind !== all[0].kind));
}

export function joinStreetUnit(street, apt) {
  if (!apt) return street;
  const embedded = units(splitStreetUnit(street).apt);
  const separate = units(apt, true);
  if (embedded && separate && !addressUnitConflict({ street, apt })) return street;
  // Keep a conflicting bare entry explicit in the combined value so validators
  // can still detect it after the fields have been joined.
  if (embedded && separate?.[0].kind === null) return `${street} Unit ${apt}`;
  return `${street} ${apt}`;
}
